import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-petition-locale-settings',
		path: '/admin/p/:slug/locale_settings',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_petition_locale_settings" */ './index'), {
			exportName: 'AdminPetitionLocaleSettings',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: {
			header: true,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
